module.exports = __webpack_public_path__ + "static/p6-6e5219572968f61f9bf94e283b7150d7.jpg";